<div class="replace-matcard">
  <h1>{{usermanagement?.title}}</h1>
  <button mat-raised-button class="color" (click)="createUser()">
    <mat-icon class="add">add_box</mat-icon>{{addButtonText}}
  </button>
  <div class="table-container">
    <table mat-table [dataSource]="users">
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{usermanagement?.col1Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.email}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{usermanagement?.col2Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.name}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{usermanagement?.col3Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.role.name}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{usermanagement?.col4Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <mat-icon class="openCell" title="{{usermanagement?.action3}}" (click)="overridePassword(element)">vpn_key
          </mat-icon>
          <mat-icon class="openCell" title="{{usermanagement?.action4}}"
            (click)="overrideEmail(element)">edit</mat-icon>
          <mat-icon *ngIf="element.isBusinessActive === false" class="activate" title="{{usermanagement?.action1}}"
            (click)="activateUser(element)">visibility</mat-icon>
          <mat-icon *ngIf="element.isBusinessActive === true" class="deactivate" title="{{usermanagement?.action2}}"
            (click)="deactivateUser(element)">visibility_off</mat-icon>
          <mat-icon
            *ngIf="(element.role.id === 3 && logedInUser.roleId == 2) || (element.role.id === 2 && logedInUser.roleId == 1)"
            class="delete" title="{{usermanagement?.action5}}" (click)="deleteUserDialog(element)">cancel</mat-icon>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row-effect"></tr>
    </table>
  </div>
</div>
<hr class="line">